import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { IrSignalData } from '@/(routers)/boards/editor/block/modal/IrSignal';

interface BlockIrSignalState {
    signals: IrSignalData[];
    addSignal: (signal: IrSignalData) => void;
    removeSignal: (id: string) => void;
    updateSignal: (id: string, updatedData: Partial<IrSignalData>) => void;
    clearSignals: () => void;
}

export const useBlockIrSignalStore = create<BlockIrSignalState>()(
    persist(
        (set) => ({
            signals: [],
            addSignal: (signal) => set((state) => ({ signals: [...state.signals, signal] })),
            removeSignal: (id) => set((state) => ({ signals: state.signals.filter((s) => s.id !== id) })),
            updateSignal: (id, updatedData) =>
                set((state) => ({
                    signals: state.signals.map((s) => (s.id === id ? { ...s, ...updatedData } : s)),
                })),
            clearSignals: () => set({ signals: [] }),
        }),
        { name: 'KEY-BOARD-EDITOR-IR-SIGNAL' },
    ),
);
if (typeof window !== 'undefined') {
    window.addEventListener('storage', (e) => {
        if (e.key === 'KEY-BOARD-EDITOR-IR-SIGNAL') {
            useBlockIrSignalStore.persist.rehydrate();
        }
    });
}
